import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ov-logo" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "ov-txt" }

import { useLogo } from '@/composables/useLogo'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingOverlay',
  props: {
    visible: { type: Boolean },
    message: { default: 'Carregando conversas do Wootdash…' }
  },
  setup(__props: any) {



const { logoUrl } = useLogo()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "overlay",
    class: _normalizeClass({ out: !__props.visible })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(logoUrl),
        alt: "ISBET",
        style: {"height":"220px","object-fit":"contain"}
      }, null, 8, _hoisted_2)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "ov-spinner" }, null, -1)),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.message), 1)
  ], 2))
}
}

})